import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass
    {
      title: "Home",
      link: "#home",
    },
    {
      title: "Stats",
      link: "#stats",
    },
    {
      title: "How It Works",
      link: "#howitwork",
    },
    {
      title: "SVAULT Token",
      link: "#tokenomics",
    },
    {
      title: "Documents",
      link: "#document",
    },
    {
      title: "FAQ",
      link: "#faq",
    },
  ];
  return (
    <Container>
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </Container>
  );
};

export default LockerMenu;
